<header [class]="className()">

  <div class="hero-navbar__main">
    <div class="hero-navbar__top-row">
      <div class="hero-navbar__identity">
        @if (enableGoBack() || showHeading()) {
          <div class="hero-navbar__heading-row">
            @if (enableGoBack()) {
              @if (showGoBackLabel()) {
                <button
                  mat-stroked-button
                  type="button"
                  class="hero-navbar__back-button"
                  (click)="onGoBackHandler()"
                  [attr.aria-label]="goBackAriaLabel()">
                  <mat-icon>{{ goBackIcon() }}</mat-icon>
                  <span>{{ goBackLabel() }}</span>
                </button>
              } @else {
                <button
                  mat-icon-button
                  type="button"
                  class="hero-navbar__back-button"
                  (click)="onGoBackHandler()"
                  [attr.aria-label]="goBackAriaLabel()">
                  <mat-icon>{{ goBackIcon() }}</mat-icon>
                </button>
              }
            }

            <div class="hero-navbar__heading-stack">
              <div class="hero-navbar__slot hero-navbar__slot--prefix">
                <ng-content select="[prefix]"></ng-content>
              </div>

              @if (showHeading()) {
                <div class="hero-navbar__content">
                  <ng-content select="[title]"></ng-content>
                  @if (title()) {
                    <h1 class="hero-navbar__title">{{ title() }}</h1>
                  }

                  @if (description()) {
                    <p class="hero-navbar__description">{{ description() }}</p>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>

      <div class="hero-navbar__utility">
        <div class="hero-navbar__slot hero-navbar__slot--suffix">
          @if (enableAddBtn()) {
            <button
              mat-raised-button
              type="button"
              (click)="addBtnClick.emit()"
              [attr.aria-label]="addBtnLabel()">
              <mat-icon>{{ addBtnIcon() }}</mat-icon>
              <span>{{ addBtnLabel() }}</span>
            </button>
          }
          <ng-content select="[suffix]"></ng-content>
        </div>
      </div>
    </div>

    <div class="hero-navbar__supporting">
      <ng-content></ng-content>
    </div>
  </div>
</header>
